import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=53669bf8&"
import script from "./TextSection.vue?vue&type=script&lang=js&"
export * from "./TextSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports